import * as React from "react";
import { Stack } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { NavigationType } from "@/components/header/common/header-enums";

import MobileTertiaryHeader from "@/components/header/navigation/mobile/_components/tertiary-navigation/mobile-tertiary-header";
import MobileTertiaryNavigationItems from "@/components/header/navigation/mobile/_components/tertiary-navigation/mobile-tertiary-navigation-items";


type MobileTertiaryNavigationProps = {
  tertiaryHeaderLabel: string;
  tertiaryHeaderLearnMoreUrl: string;
  tertiaryNavItems: HeaderNavProps[];
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};
export default function MobileTertiaryNavigation(props: MobileTertiaryNavigationProps) {
  const { tertiaryHeaderLabel, tertiaryHeaderLearnMoreUrl, tertiaryNavItems, setActiveNavigation } = props;

  return (
    <Stack>
      <MobileTertiaryHeader
        setActiveNavigation={setActiveNavigation}
        tertiaryHeaderLabel={tertiaryHeaderLabel}
        tertiaryHeaderLearnMoreUrl={tertiaryHeaderLearnMoreUrl}
      />
      <MobileTertiaryNavigationItems
        tertiaryNavItems={tertiaryNavItems}
      />
    </Stack>
  );
}
